import GenderTypePanel from "./panels/GenderTypePanel";


const tabRoutes = [
  {
    name: "Gender Types",
    path: "/gender-types",
    component: <GenderTypePanel />
  }
  // {
  //   name: "Deals",
  //   path: "/deals",
  //   component: <DealsPanel />,
  // },
  // {
  //   name: "Offers",
  //   path: "/offers",
  //   component: <OffersPanel />,
  // },
];

export default tabRoutes;

